'use strict';

/**
 *
 * @name: brightcoveNewHelperServ
 *
 */

function BrightcoveNewHelperService() {

  'ngInject';

  var videoProgress = {
    time: 0,
    videoId: 0
  };

  function saveVideoProgress(time, videoId) {

    videoProgress = {
      time: time,
      videoId: videoId
    };
  }

  function getVideoProgress(videoId) {

    return videoProgress.videoId === videoId ? videoProgress.time : 0;
  }

  function resetVideoProgress() {

    videoProgress = {
      time: 0,
      videoId: 0
    };
  }

  return {
    saveVideoProgress: saveVideoProgress,
    getVideoProgress: getVideoProgress,
    resetVideoProgress: resetVideoProgress
  };
}

export default BrightcoveNewHelperService;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-player-brightcove/nn-player-brightcove-new-helper.factory.js